import type { Logger } from '@feature-hub/logger';
import type { VueFormatterServiceInterface, LocaleService } from '../types/feature-service-types';
import { getPerTileWltpCompliance } from '../wltpCompliance';
import { mapFaceContent, mapHeadlessContent } from '../context/ContentContext/utils/mappers';
import type { TilesContent } from '../context/ContentContext/contentTypes';

export interface SsrWltpPrecheckArgs {
  isMarketComplianceEnabled: boolean;
  content: unknown;
  vueFormatterService?: VueFormatterServiceInterface;
  localeService?: LocaleService;
  logger?: Pick<Logger, 'warn' | 'error'>;
}

export const runSsrWltpPrecheck = async ({
  isMarketComplianceEnabled,
  content,
  vueFormatterService,
  localeService,
  logger,
}: SsrWltpPrecheckArgs): Promise<boolean[] | undefined> => {
  if (!isMarketComplianceEnabled) return undefined;
  if (!vueFormatterService || !localeService) return undefined;

  try {
    let tilesContent: TilesContent;
    if ((content as Record<string, unknown>).__type === 'aem-headless') {
      tilesContent = mapHeadlessContent(content as Parameters<typeof mapHeadlessContent>[0]);
    } else {
      tilesContent = mapFaceContent(content as Parameters<typeof mapFaceContent>[0]);
    }
    const { tiles } = tilesContent;
    const allKeys = tiles.flatMap((tile) => tile.wltpKeys ?? []);
    if (!allKeys.length) {
      return tiles.map(() => true);
    }

    return await getPerTileWltpCompliance(tiles, vueFormatterService, localeService, logger);
  } catch (err) {
    logger?.warn('WLTP SSR compliance pre-check failed', err);
    return undefined;
  }
};

// Alias for call sites using PreCheck casing.
export const runSsrWltpPreCheck = runSsrWltpPrecheck;
